import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CinematicJourney } from './components/CinematicJourney';
import { EN_CONTENT } from './data/siteContentEN';
import { ES_CONTENT } from './data/siteContent';
export function App() {
  return <main className="w-full bg-[var(--ms-forest-deep)]" data-id="element-0" data-mp="3k7i3114kju0l">
      <Routes data-id="element-1" data-mp="3fbjcp7zok1xj">
        <Route path="/" element={<CinematicJourney key={ES_CONTENT.language} content={ES_CONTENT} data-id="element-3" data-mp="3f8f31v3g4dzh" />} data-id="element-2" data-mp="3fb14re3nnz9s" />
        <Route path="/EN" element={<CinematicJourney key={EN_CONTENT.language} content={EN_CONTENT} data-id="element-5" data-mp="2riklj086m18w" />} data-id="element-4" data-mp="2rlfb1661yc96" />
        <Route path="*" element={<Navigate to="/" replace data-id="element-7" data-mp="31aqdwb2cikom" />} data-id="element-6" data-mp="2mnngs5hxqe1t" />
      </Routes>
    </main>;
}